import React, { useEffect, useMemo, useState } from "react";

const Pagination = ({
  totalResults = 0,
  resultsPerPage = 10,
  onChange,
  label = "Pagination",
  className = "",
}) => {
  const totalPages = Math.max(1, Math.ceil(totalResults / resultsPerPage));
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    setActivePage((prev) => Math.min(prev, totalPages));
  }, [totalPages]);

  const pages = useMemo(() => {
    const windowSize = 5;
    const start = Math.max(1, activePage - 2);
    const end = Math.min(totalPages, start + windowSize - 1);
    const adjustedStart = Math.max(1, end - windowSize + 1);

    return Array.from({ length: end - adjustedStart + 1 }, (_, idx) => adjustedStart + idx);
  }, [activePage, totalPages]);

  const goToPage = (page) => {
    const nextPage = Math.max(1, Math.min(page, totalPages));
    setActivePage(nextPage);
    if (onChange) onChange(nextPage);
  };

  if (totalResults <= resultsPerPage) return null;

  return (
    <nav aria-label={label} className={["flex items-center gap-1", className].filter(Boolean).join(" ")}>
      <button
        type="button"
        onClick={() => goToPage(activePage - 1)}
        disabled={activePage === 1}
        className="rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
      >
        Prev
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => goToPage(page)}
          className={[
            "rounded-md px-3 py-1.5 text-sm",
            page === activePage
              ? "bg-gray-600 text-white"
              : "border border-gray-300 text-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700",
          ].join(" ")}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => goToPage(activePage + 1)}
        disabled={activePage === totalPages}
        className="rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
